<template>
    <div class="page-orgCredit">
        <el-row :gutter="20" style="display:flex;">
            <el-col :span="6" class="credit-left">

<!--                                    :defaultCheckedKeys="['3689990945593495552', '3689985099685826560', '3886502419497533440']"-->
                <statistics-multi-orgs
                    :single="true"
                    @orgsChange="orgsChange"
                    @dataLoaded="orgDataLoaded"
                ></statistics-multi-orgs>
            </el-col>
            <el-col :span="18" class="credit-right">
                <el-form class="credit-query" :model="formSearch" :inline="true" size="mini">
                    <el-form-item>
                        <advanced-date-picker @change="dateChange"></advanced-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="query" round>{{$t('c.query')}}</el-button>
                    </el-form-item>
                </el-form>

                <div class="credit-chart">
                    <statistics-upload-top ref="creditScore"
                                           :statisticName="`学分排名(${legendName})`"
                                           id="creditScore"
                                           :legendName="legendName"></statistics-upload-top>
                    <el-radio-group v-model="mode" class="credit-mode" size="small"
                        @change="query">
                        <el-radio-button label="totalCredit">总学分</el-radio-button>
                        <el-radio-button label="avgCredit">平均学分</el-radio-button>
                    </el-radio-group>
                </div>

            </el-col>
        </el-row>

        <div class="credit-wrap">
            <ui-card title="学分统计" icon="nucfont inuc-menu-assemble" class="ibox">

                <div class="credit-table">
                    <el-table ref="examTable"
                              :data="creditData"
                              :stripe="true"
                              header-align="center"
                              height="400px"
                    >
                        <el-table-column type="index" width="40" align="center"></el-table-column>
                        <el-table-column prop="orgName" label="机构名称" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="peopleNum" label="人员数" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="totalHours" label="总学时" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="avgHours" label="平均学时" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="totalCredit" label="总学分" align="center"
                                         :class-name="mode==='totalCredit'?'active':''" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="avgCredit" label="平均学分" align="center"
                                         :class-name="mode==='avgCredit'?'active': ''" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
            </ui-card>
        </div>
    </div>
</template>

<script>
    import {Debounce} from '@/utils'
    import StatisticsMultiOrgs from '@/components/Statistics/StatisticsMultiOrgs'
    import StatisticsUploadTop from "@/components/Statistics/StatisticsUploadTop"
    import uiCard from '@/components/Statistics/StatisticUICard.vue'
    import AdvancedDatePicker from '@/components/DatePickerAdvanced'

    export default {
        components: {
            StatisticsMultiOrgs,
            StatisticsUploadTop,
            uiCard,
            AdvancedDatePicker
        },
        data() {
            return {
                formSearch: {
                    orgIds: [],
                    startTime: '',
                    endTime: ''
                },
                creditData: [],
                searchData: {},
                mode: 'totalCredit',
                legendName: '总学分'
            }
        },
        computed: {},
        created() {

        },
        methods: {
            orgDataLoaded() {
                //$('.el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();
            },

            orgsChange: Debounce(function (data) {
                this.formSearch.orgIds = data

                this.query()
            }, 600),

            query() {
                let searchData = {
                    ...this.formSearch
                }

                if (!this.formSearch.orgIds.length) {
                    this.creditData = []
                    this.$refs.creditScore && this.$refs.creditScore.upLoadSeption(null, 'creditScore')
                    return
                    //return this.$message.error('请选择组织机构！')
                }

                this.currentPage = 1

                this.$api.getCreditOrgs(searchData).then((res) => {
                    this.creditData = res.package;
                    this.makeChartData()
                })
            },

            makeChartData() {
                let chartData = []
                if (this.mode === 'totalCredit') {
                    this.creditData = this.creditData.sort((a, b) => b.totalCredit - a.totalCredit)
                    this.legendName = '总学分'
                    chartData = this.creditData.map(item => {
                        return {
                            id: item.orgId,
                            name: item.orgName,
                            value: item.totalCredit
                        }
                    })
                } else if (this.mode === 'avgCredit') {
                    this.creditData = this.creditData.sort((a, b) => b.avgCredit - a.avgCredit)
                    this.legendName = '平均学分'
                    chartData = this.creditData.map(item => {
                        return {
                            id: item.orgId,
                            name: item.orgName,
                            value: item.avgCredit
                        }
                    })
                }

                this.$nextTick(() => {
                    this.$refs.creditScore && this.$refs.creditScore.upLoadSeption(chartData, 'creditScore', {
                        series: {
                            label: {
                                show: true,
                            }
                        }
                    })
                })
            },

            dateChange(time) {
                this.formSearch.startTime = time[0]
                this.formSearch.endTime = time[1]
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '~@/style/const';

    .page-orgCredit {
        /deep/ {
            .ui-card,
            .ibox {
                margin-bottom: 0;
                box-shadow: none;
                border: 1px solid #dedede;
            }
            .ui-card .card-body {
                max-height: 450px;
            }
        }
    }

    .credit-left {
        .grid-content {
            height: 100%;
        }

        & /deep/ .ibox {
            height: 100%;

            .el-tree {
                height: 100%;
            }
        }
    }

    .credit-query {
        padding: 0 0 0 10px;
    }

    .credit-wrap {
        margin-top: 20px;
    }

    .credit-chart {
        @include clearfix();
        position: relative;

        .credit-mode {
            position: absolute;
            top: 60px;
            right: 40px;
        }

        /deep/ .resource-type .el-card{
            overflow: auto;
        }
    }

    .credit-table {
        margin-top: 10px;

        .sc-table thead > tr > th {
            background: #fff;
        }

        /deep/ .active {
            color: $color-theme;
            font-weight: 600;
        }
    }
</style>
